import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {toast} from 'react-toastify';
import FeedbackEdit from '../../../components/Admin/FeedbackEdit/FeedbackEdit';
import { goBack } from 'redux-router';

class FeedbackEditContainer extends Component {
  constructor(props) {
    super(props);
    this.feedbackId = props.params.id,
    this.state = {
      questions: [],
      options: [],
      newOption: ''
    }
  }

  componentDidMount = () => {
    window.scrollTo(0,0);
    axios.get(`/api/v1/admin/question_types`).then(res => {
      this.setState(prev => {
        let options = []
        const question_types = res.data.question_types
        for(let i in question_types) options.push({value: i, label: `${i[0].toUpperCase()}${i.slice(1, i.length)}`})
        return {
          ...prev,
          options
        }
      })
    })
    axios.get(`/api/v1/feedback_forms/${this.feedbackId}`).then(res => {
      this.setState(prev => ({
        ...prev,
        questions: res.data.feedback_form.questions
      }))
    })
  }

  onSubmit = async () => {
    await axios.put(`/api/v1/admin/feedback_forms/${this.feedbackId}`, {
      feedback_form: {
        primary: false,
        questions_attributes: this.state.questions
      }
    })
    toast.success('Saved!')
    this.props.goBack()
  }

  addQuestion = (question = { question_type: this.state.options[0].value || '', body: '', options: [] }) => this.setState(prev => ({...prev, questions: [ ...prev.questions, question ]}))

  onChangeOption = e => {
    const { value } = e.target
    this.setState(prev => ({...prev, newOption: value }))
  }

  addOption = index => {
    this.setState(prev => {
      let questions = [...prev.questions]
      questions[index].options.push(prev.newOption)

      return {
        ...prev,
        questions,
        newOption: ''
      }
    })
  }

  removeOption = (index, lndex) => {
    this.setState(prev => {
      let questions = [...prev.questions]
      questions[index].options.splice(lndex, 1)

      return {
        ...prev,
        questions
      }
    })
  }

  removeQuestion = index => {
    this.setState(prev => {
      let questions = [...prev.questions]
      if(questions[index].id) questions[index]._destroy = true
      else questions.splice(index, 1)

      return {
        ...prev,
        questions
      }
    })
  }

  onChange = (index, key, value, l) => {
    if(key === 'options' && typeof l === 'number') this.setState(prev => {
      let questions = [...prev.questions]
      questions[index][key][l] = value
      return {
        ...prev,
        questions
      }
    })
    else this.setState(prev => {
        let questions = [...prev.questions]
        questions[index][key] = value
        if(key === 'question_type') questions[index].options = value === 'rate' ? ['', ''] : []
        return {
            ...prev,
            questions
        }
    })
  }

  render() {
    return (
      <FeedbackEdit
        options={this.state.options}
        onSubmit={this.onSubmit}
        questions={this.state.questions}
        addQuestion={this.addQuestion}
        onChange={this.onChange}
        newOption={this.state.newOption}
        onChangeOption={this.onChangeOption}
        addOption={this.addOption}
        removeOption={this.removeOption}
        removeQuestion={this.removeQuestion}
      />
    )
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(goBack())
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackEditContainer)


// WEBPACK FOOTER //
// ./src/containers/Admin/FeedbackEdit/FeedbackEdit.js